const convertToSeconds = (timeString) => {
  if (!timeString) return 0; // If there's no time, return 0
  const [minutes, seconds] = timeString.split(":").map(Number);
  return (minutes || 0) * 60 + (seconds || 0); 
};

export const GeneratePlayerStatsByPeriod = (
  activityLog,
  numberOfPeriods,
  teamAName,
  teamBName,
  statNames
) => {

  const updatePlayerStats = (playerStats, stat) => {
      const matchingStatName = (statNames || []).find(statName => statName === stat.type);
      const iterations = playerStats[stat.period - 1]?.length || 0;
    if (matchingStatName) {
      let playerFound = false;
      for (let i = 0; i < iterations; i++) {
        if (playerStats[stat.period - 1][i].player === stat.player) {
          playerStats[stat.period - 1][i][stat.type] =
            (playerStats[stat.period - 1][i][stat.type] || 0) + 1;
          playerFound = true;
          break;
        }
      }
      if (!playerFound) {
        playerStats[stat.period - 1].push({
          player: stat.player,
          jersey: stat.jersey,
          [stat.type]: 1,
        });
      }
    }
  };

  let playerStatsTeamA = Array.from({ length: numberOfPeriods }, () => []);
  let playerStatsTeamB = Array.from({ length: numberOfPeriods }, () => []);

  activityLog.forEach((stats) => {
    if (stats.team === teamAName) {
      updatePlayerStats(playerStatsTeamA, stats);
    } else if (stats.team === teamBName) {
      updatePlayerStats(playerStatsTeamB, stats);
    }
  });


  return {
    teamAplayerStats: playerStatsTeamA,
    teamBplayerStats: playerStatsTeamB,
  };
};


export const GeneratePlayerStats = (gameData) => {
  if (!gameData || !gameData.activityLog || !gameData.teamA || !gameData.teamB) {
    return {
      teamAplayerStats: [],
      teamBplayerStats: [],
    };
  }

  let playerStatsTeamA = [];
  let playerStatsTeamB = [];

  gameData.activityLog.forEach((stats) => {
    let teamStats = stats.team === gameData.teamA.teamName ? playerStatsTeamA : playerStatsTeamB;
    let playerStats = teamStats.find(v => v.player === stats.player);

    if (playerStats) {
      playerStats[`${stats.type}`] = playerStats[`${stats.type}`] ? playerStats[`${stats.type}`] + 1 : 1;
      playerStats.playerRating += stats.rating || 0;

      if (stats.goaliePlayedTime !== undefined) {
        // Convert the goalie played time to seconds and accumulate it
        const goalieTimeInSeconds = convertToSeconds(stats.goaliePlayedTime);
        playerStats.goaliePlayedTime += goalieTimeInSeconds; // Add to the existing total
      }
    } else {
      const goalieTimeInSeconds = stats.goaliePlayedTime ? convertToSeconds(stats.goaliePlayedTime) : 0;
      teamStats.push({
        player: stats.player,
        jersey: stats.jersey,
        [`${stats.type}`]: 1,
        playerRating: stats.rating || 0,
        goaliePlayedTime: goalieTimeInSeconds, 
      });
    }
  });

  return {
    teamAplayerStats: playerStatsTeamA,
    teamBplayerStats: playerStatsTeamB,
  };
};





